import React from "react";
import { SettingsPageLayout as Layout } from "Containers/Settings/SettingsHub/SettingsPageLayout";
import { lazyLoader } from "Service/loader";
const SamsaraIntegration = lazyLoader(
  () =>
    import(
      "Containers/SamsaraIntegration/SamsaraIntegration/SamsaraIntegration"
    )
);

export const SamsaraIntegrationPage = () => {
  return (
    <Layout>
      <SamsaraIntegration />
    </Layout>
  );
};
